import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthentication } from '../../auth/hooks/useAuthentication';
import { useState } from 'react';
import { register } from '../queries/register';
import jwt from 'jwt-decode';

const STEP_ONE = 1;
const STEP_TWO = 2;
const steps = [STEP_ONE, STEP_TWO];

export const useRegisterFormStep = () => {
  const { search, state } = useLocation();
  const { refreshAuth, keycloakLoginAfterRegistration } = useAuthentication();
  const [submitting, setSubmitting] = useState(false);
  const [currentStep, setCurrentStep] = useState(STEP_ONE);
  const navigate = useNavigate();

  const params = new URLSearchParams(search);
  const registerStrategyToken = params.get('token');
  const getPayload = () => {
    try {
      return jwt(registerStrategyToken);
    } catch {
      return undefined;
    }
  };

  const payload = getPayload();

  const methods = useForm({
    defaultValues: {
      email: payload?.email ?? state?.email ?? params.get('sponsorship_email') ?? '',
      firstName: payload?.firstName ?? state?.firstName ?? '',
      lastName: payload?.lastName ?? state?.lastName ?? '',
      postalCode: state ? state.postal_code : '',
      address: state ? state.street + ' ' + state.street_number : '',
      city: state ? state.city : ''
    },
  });

  const handleNextStep = async () => {
    const valid = await methods.trigger();
    if (valid && currentStep === steps.length) {
      setSubmitting(true);
      const data = methods.getValues();

      try {
        const res = await register(data, registerStrategyToken);
        setSubmitting(false);
        if (res.status === 201) {
          refreshAuth(res.data.token);
          navigate('/registration-success', { state: { email: data.email } });
        }
      } catch {
        setSubmitting(false);
      }

      return;
    }
    valid && setCurrentStep(state => state + 1);
  };

  const handleBackStep = () => {
    if (currentStep - 1 > 0) {
      setCurrentStep(state => state - 1);
    }
  };

  return { methods, handleBackStep, handleNextStep, submitting, currentStep };
};